import { useController } from "react-hook-form";
import { TextInput as CustomTextInput } from "../../components";
import { TextInputProps } from "./types";

export default function TextInput({ name, control, rules, errorClassName, ...props }: TextInputProps) {
  const {
    field: { onChange: onChangeText, ref, ...field },
    fieldState: { error },
  } = useController({ control, name, rules });

  return (
    <CustomTextInput
      testID={name}
      blurOnSubmit={false}
      returnKeyType="next"
      {...{ ...props, ...field, ...{ ref, error, onChangeText, errorClassName } }}
    />
  );
}
